var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrande(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 606,
    viewBox: "0 0 584 606",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584 413.466L583.945 441.206C583.945 443.455 582.446 445.697 579.503 447.464L311.354 603.316C305.366 606.797 295.527 606.797 289.428 603.316L4.59985 438.728C1.55432 437.015 0 434.664 0 432.367L0.0552298 404.674C0.0552298 407.026 1.60166 409.275 4.65508 411.09L584.008 413.466H584Z",
    fill: "#117A16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.199 604.863V577.154C291.898 576.752 290.643 576.27 289.546 575.631L4.64728 411.098C1.59386 409.299 0.063209 407.01 0.063209 404.674L0.0158691 432.383C0.0158691 434.671 1.54652 437.007 4.59994 438.759L289.452 603.34C290.58 603.979 291.858 604.46 293.199 604.871",
    fill: "#2B9E31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M579.486 419.732C360.768 546.92 420.614 512.1 311.409 575.6C305.42 579.135 295.581 579.135 289.522 575.6L18.7302 419.227L4.67027 411.09C3.97595 410.712 3.40787 410.27 2.90291 409.828C-1.38134 406.355 -0.821153 401.502 4.54403 398.408L272.622 242.54C278.673 239.005 288.449 239.005 294.501 242.54L579.423 407.05C585.475 410.585 585.538 416.26 579.486 419.732Z",
    fill: "#55BE5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.844 316.859L155.802 338.781L155.79 345.527C155.79 345.986 155.479 346.452 154.868 346.809C153.634 347.525 151.628 347.519 150.382 346.809C149.753 346.446 149.441 345.974 149.453 345.509L149.465 338.721L149.507 316.854C149.507 317.325 149.819 317.79 150.436 318.142C151.681 318.858 153.688 318.858 154.922 318.142C155.527 317.79 155.844 317.331 155.844 316.859Z",
    fill: "#9E0038"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.501 323.607L149.471 338.717C150.424 339.23 151.532 339.498 152.7 339.498C153.808 339.498 154.874 339.259 155.803 338.782L155.833 323.607H149.495H149.501Z",
    fill: "#9E0038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.995 305.336L178.953 320.135C178.953 320.403 178.774 320.678 178.42 320.887C177.935 321.167 152.526 335.876 154.006 335.023L154.048 320.224L178.462 306.088C178.815 305.879 178.995 305.61 178.995 305.336Z",
    fill: "#2B9E31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.047 320.224L154.005 335.023C153.287 335.441 152.125 335.441 151.4 335.023C135.599 325.933 139.516 328.194 126.824 320.887C126.458 320.678 126.273 320.409 126.273 320.135L126.327 305.336C126.327 305.604 126.506 305.885 126.86 306.088L151.442 320.224C152.161 320.642 153.323 320.642 154.047 320.224Z",
    fill: "#99D89C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.456 304.585C179.18 305.002 179.18 305.67 178.462 306.088L154.041 320.219C153.323 320.636 152.161 320.636 151.436 320.219L126.86 306.088C126.135 305.67 126.135 305.002 126.854 304.585L151.274 290.454C151.993 290.036 153.155 290.036 153.88 290.454L178.456 304.585Z",
    fill: "#77CB7B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.952 290.889L174.916 303.415C174.916 303.642 174.766 303.874 174.467 304.047L153.802 316.007L153.838 303.481L174.503 291.521C174.802 291.342 174.958 291.115 174.958 290.889H174.952Z",
    fill: "#2B9E31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.826 303.481L153.79 316.007C153.185 316.359 152.196 316.359 151.585 316.007L130.789 304.053C130.477 303.874 130.328 303.642 130.328 303.409L130.364 290.889C130.364 291.121 130.519 291.348 130.825 291.521L151.621 303.481C152.232 303.833 153.221 303.833 153.826 303.481Z",
    fill: "#99D89C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.49 290.251C175.101 290.603 175.107 291.17 174.496 291.522L153.831 303.481C153.226 303.833 152.238 303.833 151.627 303.481L130.83 291.522C130.219 291.17 130.213 290.603 130.824 290.251L151.489 278.291C152.094 277.939 153.082 277.939 153.693 278.291L174.49 290.251Z",
    fill: "#77CB7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.519 277.318L171.489 287.918C171.489 288.109 171.363 288.306 171.106 288.449L153.616 298.572L153.646 287.972L171.136 277.849C171.393 277.7 171.519 277.509 171.519 277.312V277.318Z",
    fill: "#2B9E31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.646 287.978L153.616 298.577C153.101 298.876 152.269 298.876 151.753 298.577L134.155 288.461C133.892 288.312 133.766 288.115 133.766 287.918L133.796 277.324C133.796 277.521 133.928 277.712 134.185 277.861L151.783 287.984C152.298 288.282 153.137 288.282 153.646 287.984V287.978Z",
    fill: "#99D89C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.13 276.782C171.645 277.08 171.651 277.563 171.136 277.855L153.646 287.978C153.131 288.276 152.298 288.276 151.783 287.978L134.179 277.855C133.664 277.557 133.658 277.074 134.173 276.782L151.664 266.659C152.179 266.361 153.011 266.361 153.526 266.659L171.13 276.782Z",
    fill: "#77CB7B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68 276.786C145.621 277.329 145.627 278.206 144.692 278.748C143.758 279.291 142.237 279.291 141.296 278.748C140.356 278.206 140.35 277.329 141.284 276.786C142.219 276.243 143.74 276.243 144.68 276.786Z",
    fill: "#FF3F83"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.719 279.491C157.492 279.933 157.498 280.655 156.725 281.102C155.958 281.543 154.707 281.543 153.934 281.102C153.161 280.661 153.155 279.939 153.922 279.491C154.689 279.05 155.94 279.044 156.713 279.491H156.719Z",
    fill: "#FF3F83"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.03 270.958C156.905 271.459 156.911 272.276 156.042 272.783C155.174 273.29 153.76 273.284 152.88 272.783C151.999 272.282 151.999 271.465 152.868 270.958C153.736 270.451 155.15 270.457 156.03 270.958Z",
    fill: "#FF3F83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.153 345.041L117.111 366.962L117.1 373.709C117.1 374.168 116.794 374.633 116.193 374.991C114.98 375.707 113.008 375.701 111.784 374.991C111.166 374.627 110.86 374.156 110.872 373.691L110.883 366.903L110.925 345.035C110.925 345.506 111.231 345.972 111.837 346.324C113.061 347.039 115.033 347.039 116.246 346.324C116.841 345.972 117.153 345.512 117.153 345.041Z",
    fill: "#9E0038"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.919 351.789L110.889 366.898C111.825 367.411 112.914 367.68 114.062 367.68C115.151 367.68 116.199 367.441 117.111 366.964L117.141 351.789H110.913H110.919Z",
    fill: "#9E0038"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.904 333.518L139.863 348.317C139.863 348.585 139.686 348.859 139.339 349.068C138.862 349.349 113.892 364.058 115.346 363.205L115.387 348.406L139.38 334.269C139.728 334.06 139.904 333.792 139.904 333.518Z",
    fill: "#2B9E31"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.387 348.406L115.345 363.205C114.639 363.623 113.497 363.623 112.785 363.205C97.2561 354.114 101.106 356.375 88.6324 349.068C88.2733 348.859 88.0908 348.591 88.0908 348.317L88.1438 333.518C88.1438 333.786 88.3204 334.066 88.6677 334.269L112.826 348.406C113.532 348.824 114.674 348.824 115.387 348.406Z",
    fill: "#99D89C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M139.374 332.766C140.086 333.184 140.086 333.852 139.38 334.27L115.381 348.4C114.674 348.818 113.532 348.818 112.82 348.4L88.6678 334.27C87.9555 333.852 87.9555 333.184 88.6619 332.766L112.661 318.635C113.368 318.218 114.51 318.218 115.222 318.635L139.374 332.766Z",
    fill: "#77CB7B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.931 319.07L135.896 331.597C135.896 331.823 135.749 332.056 135.454 332.229L115.146 344.189L115.181 331.662L135.49 319.703C135.784 319.524 135.937 319.297 135.937 319.07H135.931Z",
    fill: "#2B9E31"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.169 331.662L115.133 344.189C114.539 344.541 113.568 344.541 112.967 344.189L92.5292 332.235C92.2231 332.056 92.0759 331.823 92.0759 331.591L92.1112 319.07C92.1112 319.303 92.2643 319.53 92.5645 319.703L113.002 331.662C113.603 332.014 114.574 332.014 115.169 331.662Z",
    fill: "#99D89C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M135.476 318.433C136.077 318.785 136.083 319.351 135.482 319.703L115.174 331.663C114.579 332.015 113.608 332.015 113.008 331.663L92.5697 319.703C91.9693 319.351 91.9634 318.785 92.5638 318.433L112.872 306.473C113.467 306.121 114.438 306.121 115.039 306.473L135.476 318.433Z",
    fill: "#77CB7B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.557 305.5L132.528 316.1C132.528 316.291 132.404 316.488 132.151 316.631L114.962 326.753L114.992 316.153L132.18 306.031C132.434 305.882 132.557 305.691 132.557 305.494V305.5Z",
    fill: "#2B9E31"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M114.992 316.159L114.963 326.759C114.457 327.057 113.638 327.057 113.132 326.759L95.8377 316.642C95.5787 316.493 95.4551 316.296 95.4551 316.1L95.4845 305.506C95.4845 305.703 95.614 305.894 95.8671 306.043L113.162 316.165C113.668 316.463 114.492 316.463 114.992 316.165V316.159Z",
    fill: "#99D89C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.175 304.963C132.681 305.262 132.687 305.745 132.181 306.037L114.992 316.16C114.486 316.458 113.668 316.458 113.162 316.16L95.8611 306.037C95.3549 305.739 95.349 305.256 95.8553 304.963L113.044 294.841C113.55 294.543 114.368 294.543 114.875 294.841L132.175 304.963Z",
    fill: "#77CB7B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.181 304.968C107.105 305.51 107.111 306.387 106.193 306.93C105.275 307.473 103.779 307.473 102.855 306.93C101.931 306.387 101.925 305.51 102.844 304.968C103.762 304.425 105.257 304.425 106.181 304.968Z",
    fill: "#FF3F83"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M118.012 307.673C118.771 308.115 118.777 308.836 118.018 309.284C117.265 309.725 116.034 309.725 115.275 309.284C114.516 308.842 114.51 308.121 115.263 307.673C116.017 307.232 117.247 307.226 118.006 307.673H118.012Z",
    fill: "#FF3F83"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.335 299.14C118.195 299.641 118.2 300.458 117.347 300.965C116.493 301.472 115.104 301.466 114.239 300.965C113.374 300.464 113.374 299.647 114.227 299.14C115.081 298.633 116.47 298.639 117.335 299.14Z",
    fill: "#FF3F83"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5716 373.223L78.5297 395.144L78.5177 401.89C78.5177 402.35 78.2062 402.815 77.5953 403.173C76.3614 403.888 74.3548 403.883 73.109 403.173C72.48 402.809 72.1685 402.338 72.1805 401.872L72.1925 395.084L72.2344 373.217C72.2344 373.688 72.5459 374.153 73.1628 374.505C74.4087 375.221 76.4153 375.221 77.6492 374.505C78.2541 374.153 78.5716 373.694 78.5716 373.223Z",
    fill: "#9E0038"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2287 379.971L72.1987 395.08C73.1511 395.593 74.2592 395.861 75.4272 395.861C76.5353 395.861 77.6015 395.623 78.5299 395.145L78.5599 379.971H72.2227H72.2287Z",
    fill: "#9E0038"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.722 361.699L101.68 376.498C101.68 376.767 101.501 377.041 101.147 377.25C100.662 377.53 75.2536 392.24 76.7331 391.387L76.775 376.588L101.189 362.451C101.543 362.242 101.722 361.974 101.722 361.699Z",
    fill: "#2B9E31"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7746 376.588L76.7327 391.387C76.0139 391.804 74.8519 391.804 74.1271 391.387C58.3261 382.296 62.2434 384.557 49.551 377.25C49.1857 377.041 49 376.773 49 376.498L49.0539 361.699C49.0539 361.968 49.2336 362.248 49.587 362.451L74.169 376.588C74.8878 377.005 76.0498 377.005 76.7746 376.588Z",
    fill: "#99D89C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.183 360.948C101.908 361.366 101.908 362.034 101.189 362.451L76.7687 376.582C76.0499 377 74.8879 377 74.1631 376.582L49.5871 362.451C48.8623 362.034 48.8623 361.366 49.5811 360.948L74.0014 346.817C74.7202 346.4 75.8822 346.4 76.6069 346.817L101.183 360.948Z",
    fill: "#77CB7B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6792 347.252L97.6433 359.778C97.6433 360.005 97.4935 360.238 97.194 360.411L76.5293 372.37L76.5652 359.844L97.23 347.884C97.5295 347.705 97.6852 347.479 97.6852 347.252H97.6792Z",
    fill: "#2B9E31"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5529 359.844L76.5169 372.37C75.9119 372.722 74.9236 372.722 74.3127 372.37L53.5162 360.417C53.2047 360.238 53.0549 360.005 53.0549 359.772L53.0909 347.252C53.0909 347.485 53.2466 347.711 53.5521 347.884L74.3486 359.844C74.9596 360.196 75.9479 360.196 76.5529 359.844Z",
    fill: "#99D89C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2169 346.614C97.8279 346.966 97.8339 347.533 97.2229 347.885L76.5582 359.844C75.9532 360.196 74.9649 360.196 74.3539 359.844L53.5574 347.885C52.9465 347.533 52.9405 346.966 53.5514 346.614L74.2162 334.655C74.8211 334.303 75.8094 334.303 76.4204 334.655L97.2169 346.614Z",
    fill: "#77CB7B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2465 333.682L94.2165 344.281C94.2165 344.472 94.0907 344.669 93.8332 344.812L76.343 354.935L76.373 344.335L93.8631 334.213C94.1207 334.063 94.2465 333.873 94.2465 333.676V333.682Z",
    fill: "#2B9E31"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3734 344.341L76.3435 354.941C75.8284 355.239 74.9958 355.239 74.4807 354.941L56.8827 344.824C56.6192 344.675 56.4934 344.478 56.4934 344.281L56.5233 333.688C56.5233 333.884 56.6551 334.075 56.9127 334.224L74.5106 344.347C75.0258 344.645 75.8643 344.645 76.3734 344.347V344.341Z",
    fill: "#99D89C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8576 333.145C94.3727 333.443 94.3787 333.926 93.8636 334.219L76.3734 344.341C75.8583 344.639 75.0258 344.639 74.5106 344.341L56.9067 334.219C56.3915 333.92 56.3856 333.437 56.9007 333.145L74.3908 323.023C74.906 322.724 75.7386 322.724 76.2537 323.023L93.8576 333.145Z",
    fill: "#77CB7B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4077 333.149C68.3481 333.692 68.3541 334.569 67.4197 335.112C66.4853 335.655 64.9639 335.655 64.0235 335.112C63.0831 334.569 63.0771 333.692 64.0115 333.149C64.9459 332.606 66.4673 332.606 67.4077 333.149Z",
    fill: "#FF3F83"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4464 335.855C80.2191 336.296 80.2251 337.018 79.4524 337.465C78.6857 337.907 77.4338 337.907 76.6612 337.465C75.8885 337.024 75.8825 336.302 76.6492 335.855C77.4159 335.413 78.6677 335.407 79.4404 335.855H79.4464Z",
    fill: "#FF3F83"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7576 327.321C79.6321 327.822 79.6381 328.64 78.7695 329.147C77.901 329.654 76.4875 329.648 75.607 329.147C74.7265 328.646 74.7264 327.828 75.595 327.321C76.4635 326.814 77.8771 326.82 78.7576 327.321Z",
    fill: "#FF3F83"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M433.155 331.861L433.197 353.783L433.209 360.529C433.209 360.988 433.521 361.453 434.132 361.811C435.366 362.527 437.372 362.521 438.618 361.811C439.247 361.448 439.559 360.976 439.547 360.511L439.535 353.723L439.493 331.855C439.493 332.327 439.181 332.792 438.564 333.144C437.318 333.86 435.312 333.86 434.078 333.144C433.473 332.792 433.155 332.333 433.155 331.861Z",
    fill: "#9E0038"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M439.498 338.609L439.528 353.719C438.576 354.232 437.468 354.5 436.3 354.5C435.192 354.5 434.126 354.261 433.197 353.784L433.167 338.609H439.504H439.498Z",
    fill: "#9E0038"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M410.005 320.338L410.047 335.137C410.047 335.405 410.226 335.68 410.58 335.888C411.065 336.169 436.473 350.878 434.994 350.025L434.952 335.226L410.538 321.089C410.184 320.881 410.005 320.612 410.005 320.338Z",
    fill: "#2B9E31"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M434.952 335.226L434.994 350.025C435.713 350.443 436.875 350.443 437.6 350.025C453.401 340.935 449.484 343.196 462.176 335.888C462.541 335.68 462.727 335.411 462.727 335.137L462.673 320.338C462.673 320.606 462.493 320.887 462.14 321.089L437.558 335.226C436.839 335.644 435.677 335.644 434.952 335.226Z",
    fill: "#99D89C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M410.544 319.587C409.82 320.004 409.82 320.672 410.538 321.09L434.959 335.221C435.677 335.638 436.839 335.638 437.564 335.221L462.14 321.09C462.865 320.672 462.865 320.004 462.146 319.587L437.726 305.456C437.007 305.038 435.845 305.038 435.12 305.456L410.544 319.587Z",
    fill: "#77CB7B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M414.047 305.891L414.083 318.417C414.083 318.644 414.233 318.876 414.533 319.049L435.197 331.009L435.161 318.483L414.497 306.523C414.197 306.344 414.041 306.117 414.041 305.891H414.047Z",
    fill: "#2B9E31"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M435.174 318.483L435.21 331.009C435.815 331.361 436.803 331.361 437.414 331.009L458.211 319.055C458.522 318.876 458.672 318.644 458.672 318.411L458.636 305.891C458.636 306.123 458.48 306.35 458.175 306.523L437.378 318.483C436.767 318.835 435.779 318.835 435.174 318.483Z",
    fill: "#99D89C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M414.51 305.253C413.899 305.605 413.893 306.172 414.504 306.523L435.168 318.483C435.773 318.835 436.762 318.835 437.373 318.483L458.169 306.523C458.78 306.172 458.786 305.605 458.175 305.253L437.51 293.293C436.905 292.941 435.917 292.941 435.306 293.293L414.51 305.253Z",
    fill: "#77CB7B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M417.48 292.32L417.51 302.92C417.51 303.111 417.636 303.308 417.894 303.451L435.384 313.573L435.354 302.974L417.864 292.851C417.606 292.702 417.48 292.511 417.48 292.314V292.32Z",
    fill: "#2B9E31"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M435.353 302.98L435.383 313.579C435.898 313.877 436.731 313.877 437.246 313.579L454.844 303.463C455.108 303.314 455.233 303.117 455.233 302.92L455.203 292.326C455.203 292.523 455.072 292.714 454.814 292.863L437.216 302.986C436.701 303.284 435.862 303.284 435.353 302.986V302.98Z",
    fill: "#99D89C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M417.869 291.784C417.354 292.082 417.348 292.565 417.863 292.857L435.353 302.98C435.868 303.278 436.701 303.278 437.216 302.98L454.82 292.857C455.335 292.559 455.341 292.076 454.826 291.784L437.336 281.661C436.821 281.363 435.988 281.363 435.473 281.661L417.869 291.784Z",
    fill: "#77CB7B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M444.319 291.788C443.379 292.331 443.373 293.208 444.307 293.75C445.242 294.293 446.763 294.293 447.704 293.75C448.644 293.208 448.65 292.331 447.716 291.788C446.781 291.245 445.26 291.245 444.319 291.788Z",
    fill: "#FF3F83"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M432.281 294.493C431.508 294.935 431.502 295.657 432.275 296.104C433.042 296.545 434.293 296.545 435.066 296.104C435.839 295.663 435.845 294.941 435.078 294.493C434.311 294.052 433.06 294.046 432.287 294.493H432.281Z",
    fill: "#FF3F83"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M432.97 285.96C432.095 286.461 432.089 287.278 432.958 287.785C433.826 288.292 435.24 288.286 436.12 287.785C437.001 287.284 437.001 286.467 436.132 285.96C435.264 285.453 433.85 285.459 432.97 285.96Z",
    fill: "#FF3F83"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M471.848 360.043L471.889 381.964L471.901 388.711C471.901 389.17 472.207 389.635 472.807 389.993C474.02 390.709 475.992 390.703 477.216 389.993C477.834 389.629 478.14 389.158 478.129 388.693L478.117 381.905L478.076 360.037C478.076 360.508 477.769 360.974 477.163 361.326C475.939 362.041 473.967 362.041 472.754 361.326C472.16 360.974 471.848 360.514 471.848 360.043Z",
    fill: "#9E0038"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M478.081 366.791L478.11 381.9C477.174 382.413 476.085 382.682 474.938 382.682C473.849 382.682 472.801 382.443 471.888 381.966L471.859 366.791H478.087H478.081Z",
    fill: "#9E0038"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M449.096 348.52L449.137 363.319C449.137 363.587 449.314 363.861 449.661 364.07C450.138 364.35 475.108 379.06 473.654 378.207L473.613 363.408L449.62 349.271C449.272 349.062 449.096 348.794 449.096 348.52Z",
    fill: "#2B9E31"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M473.613 363.408L473.655 378.207C474.361 378.625 475.503 378.625 476.215 378.207C491.744 369.116 487.894 371.377 500.368 364.07C500.727 363.861 500.909 363.593 500.909 363.319L500.856 348.52C500.856 348.788 500.68 349.068 500.332 349.271L476.174 363.408C475.468 363.826 474.326 363.826 473.613 363.408Z",
    fill: "#99D89C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M449.626 347.768C448.914 348.186 448.914 348.854 449.62 349.271L473.619 363.402C474.326 363.82 475.468 363.82 476.18 363.402L500.332 349.271C501.045 348.854 501.045 348.186 500.338 347.768L476.339 333.637C475.632 333.22 474.49 333.22 473.778 333.637L449.626 347.768Z",
    fill: "#77CB7B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M453.069 334.072L453.104 346.599C453.104 346.825 453.251 347.058 453.546 347.231L473.854 359.191L473.819 346.664L453.51 334.705C453.216 334.526 453.063 334.299 453.063 334.072H453.069Z",
    fill: "#2B9E31"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M473.831 346.664L473.866 359.191C474.461 359.543 475.432 359.543 476.033 359.191L496.471 347.237C496.777 347.058 496.924 346.825 496.924 346.593L496.889 334.072C496.889 334.305 496.735 334.532 496.435 334.705L475.997 346.664C475.397 347.016 474.426 347.016 473.831 346.664Z",
    fill: "#99D89C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M453.523 333.435C452.923 333.786 452.917 334.353 453.517 334.705L473.826 346.665C474.42 347.017 475.392 347.017 475.992 346.665L496.43 334.705C497.03 334.353 497.036 333.786 496.436 333.435L476.127 321.475C475.533 321.123 474.562 321.123 473.961 321.475L453.523 333.435Z",
    fill: "#77CB7B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M456.443 320.502L456.472 331.102C456.472 331.293 456.596 331.489 456.849 331.633L474.038 341.755L474.008 331.155L456.82 321.033C456.566 320.884 456.443 320.693 456.443 320.496V320.502Z",
    fill: "#2B9E31"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M474.008 331.161L474.037 341.761C474.543 342.059 475.362 342.059 475.868 341.761L493.162 331.644C493.421 331.495 493.545 331.298 493.545 331.102L493.515 320.508C493.515 320.705 493.386 320.896 493.133 321.045L475.838 331.167C475.332 331.465 474.508 331.465 474.008 331.167V331.161Z",
    fill: "#99D89C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M456.825 319.965C456.319 320.264 456.313 320.747 456.819 321.039L474.008 331.161C474.514 331.46 475.332 331.46 475.838 331.161L493.139 321.039C493.645 320.741 493.651 320.258 493.145 319.965L475.956 309.843C475.45 309.545 474.632 309.545 474.125 309.843L456.825 319.965Z",
    fill: "#77CB7B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M482.819 319.97C481.895 320.512 481.889 321.389 482.807 321.932C483.726 322.475 485.221 322.475 486.145 321.932C487.069 321.389 487.075 320.512 486.157 319.97C485.238 319.427 483.743 319.427 482.819 319.97Z",
    fill: "#FF3F83"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M470.988 322.675C470.229 323.116 470.223 323.838 470.982 324.286C471.735 324.727 472.966 324.727 473.725 324.286C474.484 323.844 474.49 323.122 473.737 322.675C472.983 322.234 471.753 322.228 470.994 322.675H470.988Z",
    fill: "#FF3F83"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M471.665 314.142C470.805 314.643 470.8 315.46 471.653 315.967C472.507 316.474 473.896 316.468 474.761 315.967C475.626 315.466 475.626 314.649 474.773 314.142C473.919 313.635 472.53 313.641 471.665 314.142Z",
    fill: "#FF3F83"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M510.428 388.225L510.47 410.146L510.482 416.892C510.482 417.351 510.794 417.817 511.405 418.175C512.639 418.89 514.645 418.884 515.891 418.175C516.52 417.811 516.831 417.34 516.819 416.874L516.808 410.086L516.766 388.219C516.766 388.69 516.454 389.155 515.837 389.507C514.591 390.223 512.585 390.223 511.351 389.507C510.746 389.155 510.428 388.696 510.428 388.225Z",
    fill: "#9E0038"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M516.771 394.973L516.801 410.082C515.849 410.595 514.741 410.863 513.573 410.863C512.465 410.863 511.398 410.625 510.47 410.147L510.44 394.973H516.777H516.771Z",
    fill: "#9E0038"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M487.278 376.701L487.32 391.5C487.32 391.769 487.499 392.043 487.853 392.252C488.338 392.532 513.746 407.242 512.267 406.389L512.225 391.59L487.811 377.453C487.457 377.244 487.278 376.976 487.278 376.701Z",
    fill: "#2B9E31"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M512.225 391.59L512.267 406.389C512.986 406.806 514.148 406.806 514.873 406.389C530.674 397.298 526.757 399.559 539.449 392.252C539.814 392.043 540 391.775 540 391.5L539.946 376.701C539.946 376.97 539.766 377.25 539.413 377.453L514.831 391.59C514.112 392.007 512.95 392.007 512.225 391.59Z",
    fill: "#99D89C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M487.817 375.95C487.092 376.367 487.092 377.036 487.811 377.453L512.232 391.584C512.95 392.002 514.112 392.002 514.837 391.584L539.413 377.453C540.138 377.036 540.138 376.367 539.419 375.95L514.999 361.819C514.28 361.401 513.118 361.401 512.393 361.819L487.817 375.95Z",
    fill: "#77CB7B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M491.32 362.254L491.356 374.78C491.356 375.007 491.506 375.24 491.805 375.413L512.47 387.372L512.434 374.846L491.77 362.886C491.47 362.707 491.314 362.481 491.314 362.254H491.32Z",
    fill: "#2B9E31"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M512.447 374.846L512.483 387.372C513.088 387.724 514.076 387.724 514.687 387.372L535.484 375.419C535.795 375.24 535.945 375.007 535.945 374.774L535.909 362.254C535.909 362.487 535.753 362.713 535.448 362.886L514.651 374.846C514.04 375.198 513.052 375.198 512.447 374.846Z",
    fill: "#99D89C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M491.783 361.616C491.172 361.968 491.166 362.535 491.777 362.887L512.441 374.846C513.046 375.198 514.035 375.198 514.646 374.846L535.442 362.887C536.053 362.535 536.059 361.968 535.448 361.616L514.783 349.657C514.178 349.305 513.19 349.305 512.579 349.657L491.783 361.616Z",
    fill: "#77CB7B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M494.753 348.684L494.783 359.283C494.783 359.474 494.909 359.671 495.167 359.814L512.657 369.937L512.627 359.337L495.137 349.215C494.879 349.065 494.753 348.875 494.753 348.678V348.684Z",
    fill: "#2B9E31"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M512.626 359.343L512.656 369.942C513.171 370.241 514.004 370.241 514.519 369.942L532.117 359.826C532.381 359.677 532.506 359.48 532.506 359.283L532.476 348.689C532.476 348.886 532.345 349.077 532.087 349.226L514.489 359.349C513.974 359.647 513.135 359.647 512.626 359.349V359.343Z",
    fill: "#99D89C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M495.142 348.147C494.627 348.445 494.621 348.928 495.136 349.221L512.626 359.343C513.141 359.641 513.974 359.641 514.489 359.343L532.093 349.221C532.608 348.922 532.614 348.439 532.099 348.147L514.609 338.024C514.094 337.726 513.261 337.726 512.746 338.024L495.142 348.147Z",
    fill: "#77CB7B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M521.592 348.151C520.652 348.694 520.646 349.571 521.58 350.114C522.515 350.657 524.036 350.657 524.977 350.114C525.917 349.571 525.923 348.694 524.988 348.151C524.054 347.608 522.533 347.608 521.592 348.151Z",
    fill: "#FF3F83"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M509.554 350.857C508.781 351.298 508.775 352.02 509.548 352.467C510.315 352.909 511.566 352.909 512.339 352.467C513.112 352.026 513.118 351.304 512.351 350.857C511.584 350.415 510.332 350.409 509.56 350.857H509.554Z",
    fill: "#FF3F83"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M510.243 342.323C509.368 342.824 509.362 343.642 510.231 344.149C511.099 344.656 512.513 344.65 513.393 344.149C514.274 343.648 514.274 342.83 513.405 342.323C512.537 341.816 511.123 341.822 510.243 342.323Z",
    fill: "#FF3F83"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M423.351 435.317L292.176 511.052V167.524L423.351 91.7891V435.317Z",
    fill: "#E0E0E0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 183.707L299.719 187.387V171.832L306.091 168.152V183.707Z",
    fill: "#C6C6C6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 124.041L415.808 120.363V104.807L409.437 108.486V124.041Z",
    fill: "#C6C6C6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 175.672L313.638 179.351V163.796L320.009 160.117V175.672Z",
    fill: "#C6C6C6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M327.684 171.242L321.313 174.92V159.365L327.684 155.686V171.242Z",
    fill: "#C6C6C6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 166.811L328.987 170.489V154.933L335.359 151.256V166.811Z",
    fill: "#C6C6C6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 156.467L346.903 160.146V144.591L353.276 140.912V156.467Z",
    fill: "#C6C6C6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 152.037L354.577 155.715V140.16L360.95 136.48V152.037Z",
    fill: "#C6C6C6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 147.604L362.252 151.282V135.727L368.625 132.049V147.604Z",
    fill: "#C6C6C6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 137.262L380.169 140.941V125.386L386.54 121.707V137.262Z",
    fill: "#C6C6C6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 132.83L387.844 136.51V120.955L394.215 117.275V132.83Z",
    fill: "#C6C6C6"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 128.399L395.518 132.077V116.522L401.89 112.844V128.399Z",
    fill: "#C6C6C6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 208.524L299.719 212.202V196.647L306.091 192.969V208.524Z",
    fill: "#C6C6C6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 148.857L415.808 145.178V129.623L409.437 133.302V148.857Z",
    fill: "#C6C6C6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 200.487L313.638 204.167V188.611L320.009 184.934V200.487Z",
    fill: "#C6C6C6"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 196.057L321.313 199.736V184.181L327.685 180.502V196.057Z",
    fill: "#C6C6C6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 191.625L328.987 195.304V179.749L335.359 176.07V191.625Z",
    fill: "#C6C6C6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 181.282L346.903 184.96V169.405L353.276 165.727V181.282Z",
    fill: "#C6C6C6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 176.852L354.577 180.53V164.976L360.95 161.297V176.852Z",
    fill: "#C6C6C6"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 172.419L362.252 176.099V160.544L368.625 156.865V172.419Z",
    fill: "#C6C6C6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 162.076L380.169 165.755V150.2L386.54 146.521V162.076Z",
    fill: "#C6C6C6"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 157.646L387.844 161.325V145.77L394.215 142.09V157.646Z",
    fill: "#C6C6C6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 153.214L395.518 156.894V141.338L401.89 137.66V153.214Z",
    fill: "#C6C6C6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 233.341L299.719 237.019V221.465L306.091 217.785V233.341Z",
    fill: "#C6C6C6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 173.673L415.808 169.996V154.439L409.437 158.119V173.673Z",
    fill: "#C6C6C6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 225.305L313.638 228.984V213.429L320.009 209.75V225.305Z",
    fill: "#C6C6C6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 220.874L321.313 224.552V208.998L327.685 205.318V220.874Z",
    fill: "#C6C6C6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 216.442L328.987 220.121V204.565L335.359 200.887V216.442Z",
    fill: "#C6C6C6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 206.099L346.903 209.779V194.224L353.276 190.545V206.099Z",
    fill: "#C6C6C6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 201.669L354.577 205.347V189.793L360.95 186.113V201.669Z",
    fill: "#C6C6C6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 197.237L362.252 200.916V185.36L368.625 181.682V197.237Z",
    fill: "#C6C6C6"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 186.894L380.169 190.573V175.017L386.54 171.34V186.894Z",
    fill: "#C6C6C6"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 182.463L387.844 186.142V170.588L394.215 166.908V182.463Z",
    fill: "#C6C6C6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 178.032L395.518 181.71V166.155L401.89 162.477V178.032Z",
    fill: "#C6C6C6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 258.157L299.719 261.835V246.28L306.091 242.602V258.157Z",
    fill: "#C6C6C6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 198.489L415.808 194.811V179.256L409.437 182.934V198.489Z",
    fill: "#C6C6C6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 250.121L313.638 253.8V238.245L320.009 234.566V250.121Z",
    fill: "#C6C6C6"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 245.69L321.313 249.368V233.813L327.685 230.135V245.69Z",
    fill: "#C6C6C6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 241.259L328.987 244.937V229.383L335.359 225.703V241.259Z",
    fill: "#C6C6C6"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 230.914L346.903 234.593V219.038L353.276 215.359V230.914Z",
    fill: "#C6C6C6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 226.483L354.577 230.161V214.606L360.95 210.928V226.483Z",
    fill: "#C6C6C6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 222.051L362.252 225.731V210.176L368.625 206.496V222.051Z",
    fill: "#C6C6C6"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 211.709L380.169 215.388V199.833L386.54 196.154V211.709Z",
    fill: "#C6C6C6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 207.278L387.844 210.956V195.4L394.215 191.723V207.278Z",
    fill: "#C6C6C6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 202.846L395.518 206.526V190.97L401.89 187.291V202.846Z",
    fill: "#C6C6C6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 282.973L299.719 286.652V271.097L306.091 267.418V282.973Z",
    fill: "#C6C6C6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 223.308L415.808 219.628V204.074L409.437 207.752V223.308Z",
    fill: "#C6C6C6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 274.939L313.638 278.616V263.063L320.009 259.383V274.939Z",
    fill: "#C6C6C6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 270.507L321.313 274.187V258.631L327.685 254.953V270.507Z",
    fill: "#C6C6C6"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 266.076L328.987 269.755V254.2L335.359 250.521V266.076Z",
    fill: "#C6C6C6"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 255.732L346.903 259.409V243.856L353.276 240.176V255.732Z",
    fill: "#C6C6C6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 251.301L354.577 254.98V239.425L360.95 235.746V251.301Z",
    fill: "#C6C6C6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 246.869L362.252 250.548V234.993L368.625 231.314V246.869Z",
    fill: "#C6C6C6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 236.528L380.169 240.206V224.652L386.54 220.973V236.528Z",
    fill: "#C6C6C6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 232.096L387.844 235.775V220.22L394.215 216.541V232.096Z",
    fill: "#C6C6C6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 227.665L395.518 231.343V215.789L401.89 212.109V227.665Z",
    fill: "#C6C6C6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 307.788L299.719 311.468V295.912L306.091 292.234V307.788Z",
    fill: "#C6C6C6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 248.122L415.808 244.444V228.889L409.437 232.567V248.122Z",
    fill: "#C6C6C6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 299.754L313.638 303.433V287.878L320.009 284.199V299.754Z",
    fill: "#C6C6C6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 295.324L321.313 299.002V283.447L327.685 279.768V295.324Z",
    fill: "#C6C6C6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 290.891L328.987 294.57V279.015L335.359 275.336V290.891Z",
    fill: "#C6C6C6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 280.547L346.903 284.226V268.671L353.276 264.992V280.547Z",
    fill: "#C6C6C6"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 276.114L354.577 279.794V264.239L360.95 260.561V276.114Z",
    fill: "#C6C6C6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 271.685L362.252 275.363V259.808L368.625 256.129V271.685Z",
    fill: "#C6C6C6"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 261.341L380.169 265.02V249.465L386.54 245.785V261.341Z",
    fill: "#C6C6C6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 256.909L387.844 260.589V245.033L394.215 241.355V256.909Z",
    fill: "#C6C6C6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 252.479L395.518 256.157V240.602L401.89 236.924V252.479Z",
    fill: "#C6C6C6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 332.606L299.719 336.284V320.729L306.091 317.051V332.606Z",
    fill: "#C6C6C6"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 272.939L415.808 269.26V253.705L409.437 257.384V272.939Z",
    fill: "#C6C6C6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 324.569L313.638 328.248V312.692L320.009 309.014V324.569Z",
    fill: "#C6C6C6"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 320.139L321.313 323.818V308.263L327.685 304.584V320.139Z",
    fill: "#C6C6C6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 315.707L328.987 319.386V303.831L335.359 300.152V315.707Z",
    fill: "#C6C6C6"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 305.364L346.903 309.042V293.487L353.276 289.809V305.364Z",
    fill: "#C6C6C6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 300.933L354.577 304.612V289.057L360.95 285.377V300.933Z",
    fill: "#C6C6C6"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 296.501L362.252 300.181V284.625L368.625 280.947V296.501Z",
    fill: "#C6C6C6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 286.159L380.169 289.837V274.282L386.54 270.604V286.159Z",
    fill: "#C6C6C6"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 281.728L387.844 285.407V269.852L394.215 266.172V281.728Z",
    fill: "#C6C6C6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 277.296L395.518 280.976V265.42L401.89 261.742V277.296Z",
    fill: "#C6C6C6"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 357.422L299.719 361.101V345.547L306.091 341.867V357.422Z",
    fill: "#C6C6C6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 297.755L415.808 294.078V278.521L409.437 282.201V297.755Z",
    fill: "#C6C6C6"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 349.386L313.638 353.066V337.511L320.009 333.832V349.386Z",
    fill: "#C6C6C6"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 344.956L321.313 348.634V333.08L327.685 329.4V344.956Z",
    fill: "#C6C6C6"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 340.525L328.987 344.204V328.648L335.359 324.971V340.525Z",
    fill: "#C6C6C6"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 330.181L346.903 333.861V318.304L353.276 314.627V330.181Z",
    fill: "#C6C6C6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 325.751L354.577 329.429V313.875L360.95 310.195V325.751Z",
    fill: "#C6C6C6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 321.319L362.252 324.997V309.442L368.625 305.764V321.319Z",
    fill: "#C6C6C6"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 310.976L380.169 314.655V299.099L386.54 295.422V310.976Z",
    fill: "#C6C6C6"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 306.545L387.844 310.224V294.669L394.215 290.99V306.545Z",
    fill: "#C6C6C6"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 302.114L395.518 305.792V290.237L401.89 286.559V302.114Z",
    fill: "#C6C6C6"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 382.238L299.719 385.916V370.361L306.091 366.682V382.238Z",
    fill: "#C6C6C6"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 322.572L415.808 318.893V303.338L409.437 307.017V322.572Z",
    fill: "#C6C6C6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 374.203L313.638 377.883V362.327L320.009 358.648V374.203Z",
    fill: "#C6C6C6"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 369.772L321.313 373.45V357.894L327.685 354.217V369.772Z",
    fill: "#C6C6C6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 365.341L328.987 369.02V353.465L335.359 349.785V365.341Z",
    fill: "#C6C6C6"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 354.996L346.903 358.675V343.12L353.276 339.441V354.996Z",
    fill: "#C6C6C6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 350.565L354.577 354.243V338.688L360.95 335.01V350.565Z",
    fill: "#C6C6C6"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 346.133L362.252 349.813V334.257L368.625 330.578V346.133Z",
    fill: "#C6C6C6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 335.791L380.169 339.47V323.915L386.54 320.236V335.791Z",
    fill: "#C6C6C6"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 331.361L387.844 335.038V319.484L394.215 315.805V331.361Z",
    fill: "#C6C6C6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 326.928L395.518 330.608V315.052L401.89 311.373V326.928Z",
    fill: "#C6C6C6"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 407.055L299.719 410.734V395.179L306.091 391.5V407.055Z",
    fill: "#C6C6C6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 347.388L415.808 343.709V328.154L409.437 331.833V347.388Z",
    fill: "#C6C6C6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 399.019L313.638 402.698V387.143L320.009 383.463V399.019Z",
    fill: "#C6C6C6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 394.586L321.313 398.265V382.71L327.685 379.031V394.586Z",
    fill: "#C6C6C6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 390.157L328.987 393.835V378.28L335.359 374.602V390.157Z",
    fill: "#C6C6C6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 379.813L346.903 383.491V367.938L353.276 364.258V379.813Z",
    fill: "#C6C6C6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 375.381L354.577 379.06V363.505L360.95 359.826V375.381Z",
    fill: "#C6C6C6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 370.951L362.252 374.629V359.074L368.625 355.395V370.951Z",
    fill: "#C6C6C6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 360.608L380.169 364.286V348.731L386.54 345.053V360.608Z",
    fill: "#C6C6C6"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 356.176L387.844 359.855V344.3L394.215 340.621V356.176Z",
    fill: "#C6C6C6"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 351.746L395.518 355.424V339.869L401.89 336.189V351.746Z",
    fill: "#C6C6C6"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 431.87L299.719 435.55V419.994L306.091 416.316V431.87Z",
    fill: "#C6C6C6"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 372.204L415.808 368.525V352.971L409.437 356.649V372.204Z",
    fill: "#C6C6C6"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 423.836L313.638 427.515V411.96L320.009 408.281V423.836Z",
    fill: "#C6C6C6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 419.403L321.313 423.083V407.528L327.685 403.85V419.403Z",
    fill: "#C6C6C6"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 414.974L328.987 418.652V403.098L335.359 399.418V414.974Z",
    fill: "#C6C6C6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 404.629L346.903 408.308V392.753L353.276 389.074V404.629Z",
    fill: "#C6C6C6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 400.196L354.577 403.876V388.32L360.95 384.643V400.196Z",
    fill: "#C6C6C6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 395.766L362.252 399.445V383.89L368.625 380.211V395.766Z",
    fill: "#C6C6C6"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 385.423L380.169 389.101V373.547L386.54 369.867V385.423Z",
    fill: "#C6C6C6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 380.991L387.844 384.671V369.115L394.215 365.438V380.991Z",
    fill: "#C6C6C6"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 376.561L395.518 380.239V364.684L401.89 361.006V376.561Z",
    fill: "#C6C6C6"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M306.091 456.687L299.719 460.366V444.811L306.091 441.131V456.687Z",
    fill: "#C6C6C6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M409.437 397.021L415.808 393.342V377.787L409.437 381.466V397.021Z",
    fill: "#C6C6C6"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M320.009 448.651L313.638 452.329V436.774L320.009 433.096V448.651Z",
    fill: "#C6C6C6"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M327.685 444.219L321.313 447.898V432.343L327.685 428.664V444.219Z",
    fill: "#C6C6C6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M335.359 439.788L328.987 443.468V427.912L335.359 424.234V439.788Z",
    fill: "#C6C6C6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M353.276 429.447L346.903 433.124V417.569L353.276 413.891V429.447Z",
    fill: "#C6C6C6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M360.95 425.014L354.577 428.693V413.138L360.95 409.459V425.014Z",
    fill: "#C6C6C6"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M368.625 420.584L362.252 424.263V408.708L368.625 405.029V420.584Z",
    fill: "#C6C6C6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M386.54 410.241L380.169 413.919V398.364L386.54 394.686V410.241Z",
    fill: "#C6C6C6"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M394.215 405.81L387.844 409.489V393.934L394.215 390.254V405.81Z",
    fill: "#C6C6C6"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M401.89 401.377L395.518 405.056V389.501L401.89 385.822V401.377Z",
    fill: "#C6C6C6"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M292.176 511.052L161 435.317V91.7891L292.176 167.524V511.052Z",
    fill: "#F0F0F0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 124.041L168.544 120.363V104.807L174.915 108.486V124.041Z",
    fill: "#C6C6C6"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 183.707L284.633 187.387V171.832L278.262 168.152V183.707Z",
    fill: "#C6C6C6"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 132.077L182.463 128.399V112.844L188.834 116.522V132.077Z",
    fill: "#C6C6C6"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 136.51L190.137 132.83V117.275L196.508 120.955V136.51Z",
    fill: "#C6C6C6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 140.941L197.812 137.262V121.707L204.183 125.386V140.941Z",
    fill: "#C6C6C6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 151.282L215.727 147.604V132.049L222.1 135.727V151.282Z",
    fill: "#C6C6C6"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 155.715L223.402 152.037V136.48L229.775 140.16V155.715Z",
    fill: "#C6C6C6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 160.146L231.077 156.467V140.912L237.449 144.591V160.146Z",
    fill: "#C6C6C6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 170.489L248.993 166.811V151.256L255.365 154.933V170.489Z",
    fill: "#FFCFE0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 174.92L256.668 171.242V155.686L263.039 159.365V174.92Z",
    fill: "#FFCFE0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 179.351L264.343 175.672V160.117L270.715 163.796V179.351Z",
    fill: "#FFCFE0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 148.857L168.544 145.178V129.623L174.915 133.302V148.857Z",
    fill: "#C6C6C6"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 208.524L284.633 212.202V196.647L278.262 192.969V208.524Z",
    fill: "#C6C6C6"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 156.894L182.463 153.214V137.66L188.834 141.338V156.894Z",
    fill: "#C6C6C6"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 161.325L190.137 157.646V142.09L196.508 145.77V161.325Z",
    fill: "#C6C6C6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 165.755L197.812 162.076V146.521L204.183 150.2V165.755Z",
    fill: "#C6C6C6"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 176.099L215.727 172.419V156.865L222.1 160.544V176.099Z",
    fill: "#FFCFE0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 180.53L223.402 176.852V161.297L229.775 164.976V180.53Z",
    fill: "#FFCFE0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 184.96L231.077 181.282V165.727L237.449 169.405V184.96Z",
    fill: "#FFCFE0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 195.304L248.993 191.625V176.07L255.365 179.749V195.304Z",
    fill: "#C6C6C6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 199.736L256.668 196.057V180.502L263.039 184.181V199.736Z",
    fill: "#C6C6C6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 204.167L264.343 200.487V184.934L270.715 188.611V204.167Z",
    fill: "#C6C6C6"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 173.673L168.544 169.996V154.439L174.915 158.119V173.673Z",
    fill: "#C6C6C6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 233.341L284.633 237.019V221.465L278.262 217.785V233.341Z",
    fill: "#C6C6C6"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 181.71L182.463 178.032V162.477L188.834 166.155V181.71Z",
    fill: "#FFCFE0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 186.142L190.137 182.463V166.908L196.508 170.588V186.142Z",
    fill: "#FFCFE0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 190.573L197.812 186.894V171.34L204.183 175.017V190.573Z",
    fill: "#FFCFE0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 200.916L215.727 197.237V181.682L222.1 185.36V200.916Z",
    fill: "#C6C6C6"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 205.347L223.402 201.669V186.113L229.775 189.793V205.347Z",
    fill: "#C6C6C6"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 209.779L231.077 206.099V190.545L237.449 194.224V209.779Z",
    fill: "#C6C6C6"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 220.121L248.993 216.442V200.887L255.365 204.565V220.121Z",
    fill: "#C6C6C6"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 224.552L256.668 220.874V205.318L263.039 208.998V224.552Z",
    fill: "#C6C6C6"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 228.984L264.343 225.305V209.75L270.715 213.429V228.984Z",
    fill: "#C6C6C6"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 198.489L168.544 194.811V179.256L174.915 182.934V198.489Z",
    fill: "#C6C6C6"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 258.157L284.633 261.835V246.28L278.262 242.602V258.157Z",
    fill: "#C6C6C6"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 206.526L182.463 202.846V187.291L188.834 190.97V206.526Z",
    fill: "#C6C6C6"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 210.956L190.137 207.278V191.723L196.508 195.4V210.956Z",
    fill: "#C6C6C6"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 215.388L197.812 211.709V196.154L204.183 199.833V215.388Z",
    fill: "#C6C6C6"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 225.731L215.727 222.051V206.496L222.1 210.176V225.731Z",
    fill: "#C6C6C6"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 230.161L223.402 226.483V210.928L229.775 214.606V230.161Z",
    fill: "#C6C6C6"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 234.593L231.077 230.914V215.359L237.449 219.038V234.593Z",
    fill: "#C6C6C6"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 244.937L248.993 241.259V225.703L255.365 229.383V244.937Z",
    fill: "#C6C6C6"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 249.368L256.668 245.69V230.135L263.039 233.813V249.368Z",
    fill: "#C6C6C6"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 253.8L264.343 250.121V234.566L270.715 238.245V253.8Z",
    fill: "#C6C6C6"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 223.308L168.544 219.628V204.074L174.915 207.752V223.308Z",
    fill: "#C6C6C6"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 282.973L284.633 286.652V271.097L278.262 267.418V282.973Z",
    fill: "#C6C6C6"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 231.343L182.463 227.665V212.109L188.834 215.789V231.343Z",
    fill: "#C6C6C6"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 235.775L190.137 232.096V216.541L196.508 220.22V235.775Z",
    fill: "#C6C6C6"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 240.206L197.812 236.528V220.973L204.183 224.652V240.206Z",
    fill: "#C6C6C6"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 250.548L215.727 246.869V231.314L222.1 234.993V250.548Z",
    fill: "#C6C6C6"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 254.98L223.402 251.301V235.746L229.775 239.425V254.98Z",
    fill: "#C6C6C6"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 259.409L231.077 255.732V240.176L237.449 243.856V259.409Z",
    fill: "#C6C6C6"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 269.755L248.993 266.076V250.521L255.365 254.2V269.755Z",
    fill: "#C6C6C6"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 274.187L256.668 270.507V254.953L263.039 258.631V274.187Z",
    fill: "#C6C6C6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 278.616L264.343 274.939V259.383L270.715 263.063V278.616Z",
    fill: "#C6C6C6"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 248.122L168.544 244.444V228.889L174.915 232.567V248.122Z",
    fill: "#FFCFE0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 307.788L284.633 311.468V295.912L278.262 292.234V307.788Z",
    fill: "#FFCFE0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 256.157L182.463 252.479V236.924L188.834 240.602V256.157Z",
    fill: "#FFCFE0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 260.589L190.137 256.909V241.355L196.508 245.033V260.589Z",
    fill: "#FFCFE0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 265.02L197.812 261.341V245.785L204.183 249.465V265.02Z",
    fill: "#FFCFE0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 275.363L215.727 271.685V256.129L222.1 259.808V275.363Z",
    fill: "#FFCFE0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 279.794L223.402 276.114V260.561L229.775 264.239V279.794Z",
    fill: "#FFCFE0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 284.226L231.077 280.547V264.992L237.449 268.671V284.226Z",
    fill: "#FFCFE0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 294.57L248.993 290.891V275.336L255.365 279.015V294.57Z",
    fill: "#FFCFE0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 299.002L256.668 295.324V279.768L263.039 283.447V299.002Z",
    fill: "#FFCFE0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 303.433L264.343 299.754V284.199L270.715 287.878V303.433Z",
    fill: "#FFCFE0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 272.939L168.544 269.26V253.705L174.915 257.384V272.939Z",
    fill: "#C6C6C6"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 332.606L284.633 336.284V320.729L278.262 317.051V332.606Z",
    fill: "#C6C6C6"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 280.976L182.463 277.296V261.742L188.834 265.42V280.976Z",
    fill: "#C6C6C6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 285.407L190.137 281.728V266.172L196.508 269.852V285.407Z",
    fill: "#C6C6C6"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 289.837L197.812 286.159V270.604L204.183 274.282V289.837Z",
    fill: "#C6C6C6"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 300.181L215.727 296.501V280.947L222.1 284.625V300.181Z",
    fill: "#C6C6C6"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 304.612L223.402 300.933V285.377L229.775 289.057V304.612Z",
    fill: "#C6C6C6"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 309.042L231.077 305.364V289.809L237.449 293.487V309.042Z",
    fill: "#C6C6C6"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 319.386L248.993 315.707V300.152L255.365 303.831V319.386Z",
    fill: "#C6C6C6"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 323.818L256.668 320.139V304.584L263.039 308.263V323.818Z",
    fill: "#C6C6C6"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 328.248L264.343 324.569V309.014L270.715 312.692V328.248Z",
    fill: "#C6C6C6"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 297.755L168.544 294.078V278.521L174.915 282.201V297.755Z",
    fill: "#C6C6C6"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 357.422L284.633 361.101V345.547L278.262 341.867V357.422Z",
    fill: "#C6C6C6"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 305.792L182.463 302.114V286.559L188.834 290.237V305.792Z",
    fill: "#C6C6C6"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 310.224L190.137 306.545V290.99L196.508 294.669V310.224Z",
    fill: "#C6C6C6"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 314.655L197.812 310.976V295.422L204.183 299.099V314.655Z",
    fill: "#C6C6C6"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 324.997L215.727 321.319V305.764L222.1 309.442V324.997Z",
    fill: "#C6C6C6"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 329.429L223.402 325.751V310.195L229.775 313.875V329.429Z",
    fill: "#C6C6C6"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 333.861L231.077 330.181V314.627L237.449 318.304V333.861Z",
    fill: "#C6C6C6"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 344.204L248.993 340.525V324.971L255.365 328.648V344.204Z",
    fill: "#C6C6C6"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 348.634L256.668 344.956V329.4L263.039 333.08V348.634Z",
    fill: "#C6C6C6"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 353.066L264.343 349.386V333.832L270.715 337.511V353.066Z",
    fill: "#C6C6C6"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 322.572L168.544 318.893V303.338L174.915 307.017V322.572Z",
    fill: "#C6C6C6"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 382.238L284.633 385.916V370.361L278.262 366.682V382.238Z",
    fill: "#FFCFE0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 330.608L182.463 326.928V311.373L188.834 315.052V330.608Z",
    fill: "#C6C6C6"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 335.038L190.137 331.361V315.805L196.508 319.484V335.038Z",
    fill: "#C6C6C6"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 339.47L197.812 335.791V320.236L204.183 323.915V339.47Z",
    fill: "#C6C6C6"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 349.813L215.727 346.133V330.578L222.1 334.257V349.813Z",
    fill: "#C6C6C6"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 354.243L223.402 350.565V335.01L229.775 338.688V354.243Z",
    fill: "#C6C6C6"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 358.675L231.077 354.996V339.441L237.449 343.12V358.675Z",
    fill: "#C6C6C6"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 369.02L248.993 365.341V349.785L255.365 353.465V369.02Z",
    fill: "#C6C6C6"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 373.45L256.668 369.772V354.217L263.039 357.894V373.45Z",
    fill: "#C6C6C6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 377.883L264.343 374.203V358.648L270.715 362.327V377.883Z",
    fill: "#C6C6C6"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 347.388L168.544 343.709V328.154L174.915 331.833V347.388Z",
    fill: "#C6C6C6"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 407.055L284.633 410.734V395.179L278.262 391.5V407.055Z",
    fill: "#C6C6C6"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 355.424L182.463 351.746V336.189L188.834 339.869V355.424Z",
    fill: "#C6C6C6"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 359.855L190.137 356.176V340.621L196.508 344.3V359.855Z",
    fill: "#C6C6C6"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 364.286L197.812 360.608V345.053L204.183 348.731V364.286Z",
    fill: "#C6C6C6"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 374.629L215.727 370.951V355.395L222.1 359.074V374.629Z",
    fill: "#C6C6C6"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 379.06L223.402 375.381V359.826L229.775 363.505V379.06Z",
    fill: "#C6C6C6"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 383.491L231.077 379.813V364.258L237.449 367.938V383.491Z",
    fill: "#C6C6C6"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 393.835L248.993 390.157V374.602L255.365 378.28V393.835Z",
    fill: "#FFCFE0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 398.265L256.668 394.586V379.031L263.039 382.71V398.265Z",
    fill: "#FFCFE0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 402.698L264.343 399.019V383.463L270.715 387.143V402.698Z",
    fill: "#FFCFE0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 372.204L168.544 368.525V352.971L174.915 356.649V372.204Z",
    fill: "#C6C6C6"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 431.87L284.633 435.55V419.994L278.262 416.316V431.87Z",
    fill: "#C6C6C6"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 380.239L182.463 376.561V361.006L188.834 364.684V380.239Z",
    fill: "#C6C6C6"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 384.671L190.137 380.991V365.438L196.508 369.115V384.671Z",
    fill: "#C6C6C6"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 389.101L197.812 385.423V369.867L204.183 373.547V389.101Z",
    fill: "#C6C6C6"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 399.445L215.727 395.766V380.211L222.1 383.89V399.445Z",
    fill: "#FFCFE0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 403.876L223.402 400.196V384.643L229.775 388.32V403.876Z",
    fill: "#FFCFE0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 408.308L231.077 404.629V389.074L237.449 392.753V408.308Z",
    fill: "#FFCFE0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 418.652L248.993 414.974V399.418L255.365 403.098V418.652Z",
    fill: "#C6C6C6"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 423.083L256.668 419.403V403.85L263.039 407.528V423.083Z",
    fill: "#C6C6C6"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 427.515L264.343 423.836V408.281L270.715 411.96V427.515Z",
    fill: "#C6C6C6"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M174.915 397.021L168.544 393.342V377.787L174.915 381.466V397.021Z",
    fill: "#C6C6C6"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M278.262 456.687L284.633 460.366V444.811L278.262 441.131V456.687Z",
    fill: "#C6C6C6"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 405.056L182.463 401.377V385.822L188.834 389.501V405.056Z",
    fill: "#FFCFE0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M196.508 409.489L190.137 405.81V390.254L196.508 393.934V409.489Z",
    fill: "#FFCFE0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M204.183 413.919L197.812 410.241V394.686L204.183 398.364V413.919Z",
    fill: "#FFCFE0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M222.1 424.263L215.727 420.584V405.029L222.1 408.708V424.263Z",
    fill: "#C6C6C6"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M229.775 428.693L223.402 425.014V409.459L229.775 413.138V428.693Z",
    fill: "#C6C6C6"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M237.449 433.124L231.077 429.447V413.891L237.449 417.569V433.124Z",
    fill: "#C6C6C6"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M255.365 443.468L248.993 439.788V424.234L255.365 427.912V443.468Z",
    fill: "#C6C6C6"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M263.039 447.898L256.668 444.219V428.664L263.039 432.343V447.898Z",
    fill: "#C6C6C6"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 452.329L264.343 448.651V433.096L270.715 436.774V452.329Z",
    fill: "#C6C6C6"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M225.521 472.568L212.101 464.82V436.582L225.521 444.329V472.568Z",
    fill: "#FF3F83"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M241.076 481.549L227.656 473.802V445.562L241.076 453.31V481.549Z",
    fill: "#FF3F83"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M423.35 91.7913L292.174 16.0566L161.002 91.788L292.178 167.523L423.35 91.7913Z",
    fill: "#FF6FA2"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M401.863 91.8244L394.149 96.2674L292.184 37.4038L190.135 96.2674L182.42 91.8244L292.184 28.4316L401.863 91.8244Z",
    fill: "#FF9FC1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M354.577 96.0495L292.176 132.077V122.184L354.577 86.1562V96.0495Z",
    fill: "#9E0038"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M292.176 132.077L229.775 96.0495V86.1562L292.176 122.184V132.077Z",
    fill: "#FF0F64"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M354.577 86.1564L292.175 50.1289L229.775 86.1553L292.177 122.184L354.577 86.1564Z",
    fill: "#FF3F83"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M333.599 86.5684L292.176 110.484V81.0107L333.599 57.0957V86.5684Z",
    fill: "#9E0038"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M292.176 110.484L250.753 86.5684V57.0957L292.176 81.0107V110.484Z",
    fill: "#FF0F64"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M333.598 57.0947L292.175 33.1797L250.754 57.0947L292.177 81.0097L333.598 57.0947Z",
    fill: "#FF3F83"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M308.753 55.1997L292.176 64.7718V26.5799L308.753 17.0078V55.1997Z",
    fill: "#9E0038"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M292.176 64.7718L275.599 55.1997V17.0078L292.176 26.5799V64.7718Z",
    fill: "#FF0F64"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M308.753 17.0084L292.176 7.4375L275.599 17.0073L292.176 26.5793L308.753 17.0084Z",
    fill: "#FF3F83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrande);
export default __webpack_public_path__ + "static/media/grande.96d1fe4bba1226f5f4374fd7473b0aac.svg";
export { ForwardRef as ReactComponent };